import React, { useRef, useState, useEffect } from 'react';
import styles from '../laranjalimakids2/laranjalimakids2.module.scss';
import Perfil from './src/perfil.png';
import TopLeftImage from './src/top-left.png';
import BottomLeftImage from './src/bottom-right.png';
import LinkPersonalizado2 from '../../components/LinkPersonalizado2/linkPersonalizado2.tsx';

const Laranjalimakids2: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.laranjalimakids2}>
            <div className={styles["body-thunder"]} style={{ height: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={styles["top-left-image-wrapper"]}>
                    <img
                        className={styles["top-left-image"]}
                        src={TopLeftImage}
                        alt="Top Left Image"
                    />
                </div>
                <div className={styles["bottom-right-image-wrapper"]}>
                    <img
                        className={styles["bottom-right-image"]}
                        src={BottomLeftImage}
                        alt="Bottom Right Image"
                    />
                </div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4 mb-0">Laranja Lima Kids</h1>
                    <p className="mb-0">Horário de atendimento</p>
                    <p className="mb-0">Segunda à sexta, 09:00  às 18:30</p>
                    <p className="mb-6">Sábado, 09:00 às 14:00</p>
                    <div className={styles.links}>
                        <LinkPersonalizado2
                            href="https://wa.me/553798060102?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                            title="Whatsapp (Principal)"
                            backgroundColor="#EA7F23"
                            backgroundColorHover="#df6c08ff"
                            colorText="#FFF2DB"
                            maxWSpan
                        />
                        <LinkPersonalizado2
                            href="https://wa.me/553799369607?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                            title="Whatsapp"
                            backgroundColor="#EA7F23"
                            backgroundColorHover="#df6c08ff"
                            colorText="#FFF2DB"
                        />
                        <LinkPersonalizado2
                            href="https://www.instagram.com/laranjalimakids2?igsh=aXllYTR2bnVwMWk%3D&utm_source=qr"
                            title="Instagram"
                            backgroundColor="#EA7F23"
                            backgroundColorHover="#df6c08ff"
                            colorText="#FFF2DB"
                        />
                        <LinkPersonalizado2
                            href="https://maps.app.goo.gl/eLQ5CDBLs1cRaQwt8"
                            title="Localização"
                            backgroundColor="#EA7F23"
                            backgroundColorHover="#df6c08ff"
                            colorText="#FFF2DB"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Laranjalimakids2;
